var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"rph-socials"},[_vm._l((_vm.socials),function(item){return [_c('li',{key:item.id},[_c('RPHFooterSocialLink',{attrs:{"social":item.type,"url":item.url}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }